export default __webpack_public_path__ + "static/media/liliana_salas_barrios.0bfc44a4.jpg";